module.exports = __webpack_public_path__ + "static/one-2ca01769d776bd97fc967d95e51429c3.svg";